/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Product area the request originated from. The server builds the email subject line from this plus the reporter's company — the modal has no subject input, so there is no user-written one to use.
 */
export enum SupportRequestProductArea {
    HRIS_DATA_MANAGEMENT = 'hris_data_management',
    FILE_UPLOAD = 'file_upload',
    SURVEY_DATA = 'survey_data',
    OTHER = 'other',
}
